export class Address {
  address1 = '';
  address2 = '';
  city = '';
  state = '';
  zipcode = '';
  country = '';

  buildAddress(obj: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipcode: string;
  }) {
    this.address1 = obj.address1;
    this.address2 = obj.address2;
    this.city = obj.city;
    this.state = obj.state;
    this.zipcode = obj.zipcode;
  }

  buildAddressWithCountry(obj: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
  }) {
    this.address1 = obj.address1;
    this.address2 = obj.address2;
    this.city = obj.city;
    this.state = obj.state;
    this.zipcode = obj.zipcode;
    this.country = obj.country;
  }

  formatString(): string {
    const address1 = this.address1 ? `${this.address1}, ` : '';
    const address2 = this.address2 ? `${this.address2}, ` : '';
    const city = this.city ? `${this.city}, ` : '';
    const state = this.state ? `${this.state}, ` : '';
    const zipcode = this.zipcode ? `${this.zipcode}` : '';
    const country = this.country ? `${this.country}.` : '.';
    return `${address1}${address2}${city}${state}${zipcode}${country}`;
  }
}
